export enum fullTextSearch {
  fields = 'fullTextSearch.fields',
  looking_for = 'fullTextSearch.looking_for',
  search_in = 'fullTextSearch.search_in',
}